// extracted by mini-css-extract-plugin
export default {"layout":"layout___xngB0","size--monkey":"size--monkey___h3goO"};